import api from '../../plugins/api';

const deleteComplectation = (id) => {
  return api.post('/api/crm/cars/deleteComplectation/' + id);
};

export default deleteComplectation;
